// extracted by mini-css-extract-plugin
module.exports = {"spinner":"entity_decision_loader-module__spinner--3TFcj"};